export default __webpack_public_path__ + "static/media/news072603.a70e076a.jpg";